exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".input-file[data-v-224ae481]{display:none}.app-col[data-v-224ae481]{display:inline-block;padding:0 5px;margin-bottom:8px}.image-preview[data-v-224ae481]{display:block;max-height:400px;max-width:400px;min-height:200px;min-width:200px;width:100%;height:400px;margin:auto}", ""]);

// exports
